export default __webpack_public_path__ + "static/media/101.85a24556.jpg";